export interface MDSMenuItemHeaderProps {
  label: string;
  variant?: MDSMenuItemHeaderVariant;
}

export enum MDSMenuItemHeaderVariant {
  Beginning = "beginning",
  Middle = "middle",
}
